// Nav entry of Review (shell/nav.ts collects every routes/*.nav.ts; `order` places it in the rail, the tabs and Lisää).
// Tarkistusjono: the admin's tool (also linked from Asetukset → Ylläpito). Both people
// still raise flags on content; approvals live in Omat sanat, Asetukset and the dictionary.
import { defineNav } from '../shell/nav-entry';

export const nav = defineNav({
  id: 'review',
  path: '/review',
  icon: 'review',
  group: 'app',
  phone: 'more',
  admin: true,
  order: 1400,
  load: () => import('./Review'),
});
